import React from 'react';

import styled from 'styled-components';

import { INutritionInfo } from '@rbi-ctg/menu';

import { NutritionItem } from './nutrition-item';
import { NutritionItemGroup } from './nutrition-item-group';
import { SanityNutritionTable } from './types';

const Table = styled.table`
  margin-top: 1.5rem;
  width: 100%;
`;

const TableTitle = styled.th`
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  border-bottom: 1px solid ${Styles.color.grey.five};
  text-align: left;
`;

type NutritionTableProps = {
  nutritionTable: SanityNutritionTable;
  nutritionInfo: INutritionInfo;
  roundNutritionValue: (val: number) => number;
};

export const NutritionTable: React.FC<NutritionTableProps> = ({
  nutritionInfo,
  nutritionTable,
  roundNutritionValue,
}) => {
  const title = nutritionTable.title?.locale;
  const items = nutritionTable.items ?? [];
  if (!title || !items.length) {
    return null;
  }

  return (
    <Table data-testid="nutrition-table">
      <thead>
        <tr>
          <TableTitle colSpan={2}>{title}</TableTitle>
        </tr>
      </thead>
      <tbody>
        {items.map((item, index) => {
          if (item?.__typename === 'NutritionItem') {
            return (
              <NutritionItem
                key={item.nutritionKey || index}
                nutritionInfo={nutritionInfo}
                nutritionItem={item}
                roundNutritionValue={roundNutritionValue}
              />
            );
          } else if (item?.__typename === 'NutritionItemGroup') {
            return (
              <NutritionItemGroup
                key={item._key || index}
                nutritionInfo={nutritionInfo}
                nutritionItemGroup={item}
                roundNutritionValue={roundNutritionValue}
              />
            );
          }
          return null;
        })}
      </tbody>
    </Table>
  );
};
